import { render } from "./chatHistory.vue?vue&type=template&id=4ebc42c2"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"

import "./chatHistory.vue?vue&type=style&index=0&id=4ebc42c2&lang=scss"

import exportComponent from "C:\\Users\\pzx\\Desktop\\Master\\im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__